import { render, staticRenderFns } from "./TableManager.vue?vue&type=template&id=d8329b8c&scoped=true"
import script from "./TableManager.vue?vue&type=script&lang=js"
export * from "./TableManager.vue?vue&type=script&lang=js"
import style0 from "./TableManager.vue?vue&type=style&index=0&id=d8329b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8329b8c",
  null
  
)

export default component.exports